// Line icons (16px grid, stroke = currentColor), from the P-001 mockup's sprite; gear, bug, batch,
// chore and plan redrawn in B-001 (#6) so no two read alike. /style-guide shows every one.
const PATHS = {
  chev: <path d="M4.5 6.5 8 10l3.5-3.5" />,
  refresh: (
    <>
      <path d="M13.5 8a5.5 5.5 0 1 1-1.6-3.9" />
      <path d="M13.5 2.5v3h-3" />
    </>
  ),
  sun: (
    <>
      <circle cx="8" cy="8" r="2.8" />
      <path d="M8 1.5v1.3M8 13.2v1.3M1.5 8h1.3M13.2 8h1.3M3.4 3.4l.9.9M11.7 11.7l.9.9M3.4 12.6l.9-.9M11.7 4.3l.9-.9" />
    </>
  ),
  moon: <path d="M13 9.6A5.5 5.5 0 0 1 6.4 3a5.5 5.5 0 1 0 6.6 6.6Z" />,
  system: (
    <>
      <rect x="2" y="3" width="12" height="8" rx="1.5" />
      <path d="M6 13.5h4M8 11v2.5" />
    </>
  ),
  // A clipboard with a list (not a page: `file` is the page).
  plan: (
    <>
      <path d="M5.8 3H4.5a1 1 0 0 0-1 1v9.5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-1.3" />
      <rect x="5.8" y="1.8" width="4.4" height="2.4" rx=".8" />
      <path d="M6 7.5h4M6 10.5h4" />
    </>
  ),
  idea: (
    <>
      <path d="M5.5 10.5a4 4 0 1 1 5 0V12h-5z" />
      <path d="M6 14h4" />
    </>
  ),
  // A beetle: head, body, legs (not a dot in a ring, which read as a target or `commit`).
  bug: (
    <>
      <rect x="5" y="5.5" width="6" height="8.5" rx="3" />
      <path d="M6.3 5.6a1.7 1.7 0 0 1 3.4 0M8 7.5v6.3" />
      <path d="M5 8.5H2.5M11 8.5h2.5M5.2 11.5l-2 1.2M10.8 11.5l2 1.2M5.5 6.5 3.7 5M10.5 6.5 12.3 5" />
    </>
  ),
  // A stack of layers (the old two squares were the same drawing as `copy`).
  batch: (
    <>
      <path d="M8 2.5 14 5.5 8 8.5 2 5.5z" />
      <path d="m2 8.5 6 3 6-3M2 11.5l6 3 6-3" />
    </>
  ),
  // A wrench (three lines read as a menu).
  chore: (
    <path d="M13.56 4.64 11.64 6.55 9.45 4.36l1.91-1.92A3.3 3.3 0 0 0 7.4 6.97l-4.46 4.46a1.15 1.15 0 0 0 1.63 1.63L9.03 8.6a3.3 3.3 0 0 0 4.53-3.96Z" />
  ),
  pr: (
    <>
      <circle cx="4.5" cy="3.5" r="1.5" />
      <circle cx="4.5" cy="12.5" r="1.5" />
      <circle cx="11.5" cy="12.5" r="1.5" />
      <path d="M4.5 5v6M11.5 11V6.5A2 2 0 0 0 9.5 4.5H7.5" />
      <path d="M9 3 7.5 4.5 9 6" />
    </>
  ),
  merge: (
    <>
      <circle cx="4.5" cy="3.5" r="1.5" />
      <circle cx="4.5" cy="12.5" r="1.5" />
      <circle cx="11.5" cy="8" r="1.5" />
      <path d="M4.5 5v6M4.5 5c0 2.5 2 3 5.5 3" />
    </>
  ),
  warn: (
    <>
      <path d="M8 2.2 14.2 13H1.8z" />
      <path d="M8 6.5v3M8 11.3v.1" />
    </>
  ),
  x: <path d="m4 4 8 8M12 4l-8 8" />,
  check: <path d="m3.5 8.5 3 3 6-7" />,
  ext: <path d="M9 3h4v4M13 3 7.5 8.5M11 9.5V13H3V5h3.5" />,
  branch: (
    <>
      <circle cx="4.5" cy="3.5" r="1.5" />
      <circle cx="4.5" cy="12.5" r="1.5" />
      <circle cx="11.5" cy="5" r="1.5" />
      <path d="M4.5 5v6M11.5 6.5c0 3-7 2-7 4.5" />
    </>
  ),
  arrow: <path d="M3 8h10M9.5 4.5 13 8l-3.5 3.5" />,
  pause: <path d="M6 4v8M10 4v8" />,
  file: (
    <>
      <path d="M4 2.5h5.5L12 5v8.5H4z" />
      <path d="M9.5 2.5V5H12" />
    </>
  ),
  board: (
    <>
      <rect x="2" y="2.5" width="3.5" height="11" rx="1" />
      <rect x="6.25" y="2.5" width="3.5" height="7" rx="1" />
      <rect x="10.5" y="2.5" width="3.5" height="9" rx="1" />
    </>
  ),
  search: (
    <>
      <circle cx="7" cy="7" r="4.5" />
      <path d="m10.5 10.5 3 3" />
    </>
  ),
  // A cog: six teeth on a ring, and a hub (the old rays-around-a-dot was `sun` again).
  gear: (
    <>
      <path d="M6.71 3.79 6.87 1.6a6.5 6.5 0 0 1 2.26 0l.16 2.19A4.4 4.4 0 0 1 11 4.78l1.98-.96a6.5 6.5 0 0 1 1.13 1.96L12.29 7.01a4.4 4.4 0 0 1 0 1.98l1.82 1.23a6.5 6.5 0 0 1-1.13 1.96L11 11.22a4.4 4.4 0 0 1-1.71.99l-.16 2.19a6.5 6.5 0 0 1-2.26 0l-.16-2.19A4.4 4.4 0 0 1 5 11.22l-1.98.96a6.5 6.5 0 0 1-1.13-1.96l1.82-1.23a4.4 4.4 0 0 1 0-1.98L1.89 5.78a6.5 6.5 0 0 1 1.13-1.96L5 4.78a4.4 4.4 0 0 1 1.71-.99Z" />
      <circle cx="8" cy="8" r="1.9" />
    </>
  ),
  plus: <path d="M8 3v10M3 8h10" />,
  gh: (
    <path d="M6 13.5c-3 .9-3-1.5-4-1.8M10 14v-2.2c0-.7.1-1-.3-1.4 1.9-.2 3.8-.9 3.8-4a3.1 3.1 0 0 0-.8-2.1 2.9 2.9 0 0 0-.1-2.1s-.7-.2-2.3.9a7.9 7.9 0 0 0-4.1 0C4.6 2 3.9 2.2 3.9 2.2a2.9 2.9 0 0 0-.1 2.1 3.1 3.1 0 0 0-.8 2.1c0 3.1 1.9 3.8 3.8 4-.4.4-.4.8-.3 1.4V14" />
  ),
  commit: (
    <>
      <circle cx="8" cy="8" r="2.6" />
      <path d="M1.5 8h3.9M10.6 8h3.9" />
    </>
  ),
  tag: (
    <>
      <path d="M2.5 2.5h5l6 6-5 5-6-6z" />
      <circle cx="5.5" cy="5.5" r="1" className="fill-current stroke-none" />
    </>
  ),
  copy: (
    <>
      <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" />
      <path d="M10.5 5.5V3.5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2" />
    </>
  ),
  left: <path d="M10 3.5 5.5 8l4.5 4.5" />,
  eye: (
    <>
      <path d="M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8z" />
      <circle cx="8" cy="8" r="2" />
    </>
  ),
  signout: (
    <>
      <path d="M6.5 13.5h-3v-11h3" />
      <path d="M10 5l3 3-3 3M13 8H6.5" />
    </>
  ),
  // The fleet: two stacked machines, each with a light (P-004).
  server: (
    <>
      <rect x="2" y="2.5" width="12" height="4.5" rx="1.2" />
      <rect x="2" y="9" width="12" height="4.5" rx="1.2" />
      <path d="M4.75 4.75h.01M4.75 11.25h.01" />
    </>
  ),
} as const;

export type IconName = keyof typeof PATHS;
export const ICON_NAMES = Object.keys(PATHS) as IconName[];

const PX = { 12: 'size-3', 15: 'size-[15px]', 16: 'size-4', 18: 'size-[18px]' } as const;

/** `i` / `i-sm` are hook classes (tests find icons by them); `px` overrides the size (15, or 12 small). */
export function Icon({ name, small, label, px }: { name: IconName; small?: boolean; label?: string; px?: keyof typeof PX }) {
  return (
    <svg
      className={`${small ? 'i i-sm' : 'i'} ${PX[px ?? (small ? 12 : 15)]} flex-none fill-none stroke-current [stroke-linecap:round] [stroke-linejoin:round] [stroke-width:1.6]`}
      viewBox="0 0 16 16"
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label}
    >
      {PATHS[name]}
    </svg>
  );
}
